import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const HomeCTA = () => {
  const sectionRef = useRef(null);
  
  useEffect(() => {
    if (!sectionRef.current) return;
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-section');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    
    observer.observe(sectionRef.current);
    
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section 
      ref={sectionRef}
      className="py-24 bg-gradient-to-br from-indigo-600 via-indigo-700 to-purple-800 text-white relative overflow-hidden"
    >
      {/* Dekoratif Arka Plan */}
      <div className="absolute inset-0">
        {/* Dalgalı şekiller */}
        <div className="absolute -left-20 -top-20 w-64 h-64 bg-purple-500 rounded-full opacity-20 blur-3xl"></div>
        <div className="absolute right-0 top-1/3 w-80 h-80 bg-indigo-400 rounded-full opacity-10 blur-3xl"></div>
        <div className="absolute left-1/3 bottom-0 w-96 h-96 bg-purple-600 rounded-full opacity-10 blur-3xl"></div>
        
        {/* Müzik enstrümanı siluetleri */}
        <div className="absolute right-10 bottom-0 opacity-10 w-64 h-64">
          <svg viewBox="0 0 200 200" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M50,20 C50,10 60,10 70,10 C80,10 90,10 90,20 L90,150 C90,160 80,170 70,170 C60,170 50,160 50,150 L50,20 Z" />
            <path d="M50,40 L20,40 C10,40 10,50 10,60 L10,70 C10,80 20,90 30,90 L50,90 L50,40 Z" />
          </svg>
        </div>
      </div>
      
      <div className="container mx-auto px-6 text-center relative z-10">
        <div className="flex flex-col items-center justify-center cta-content opacity-0 transform translate-y-8 transition-all duration-1000">
          {/* Müzik notası ikonu */}
          <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mb-8">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
            </svg>
          </div>
          
          <h2 className="text-4xl sm:text-5xl font-bold mb-6 tracking-tight">
            Müzik Tutkunu musun?
          </h2>
          <p className="text-xl sm:text-2xl mb-12 max-w-2xl mx-auto leading-relaxed text-indigo-100">
            İYTE Müzik Topluluğu'na katılarak tutkunu paylaş, etkinliklerimize katıl ve kampüs hayatını müzikle doldur.
          </p>
          
          <div className="flex flex-wrap justify-center gap-6">
            <Link 
              to="/register"
              className="px-8 py-4 rounded-full bg-white text-indigo-700 font-medium shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 hover:scale-105"
            >
              Hemen Üye Ol
            </Link>
            <Link 
              to="/reserve"
              className="px-8 py-4 rounded-full bg-transparent border-2 border-white text-white font-medium hover:bg-white/10 transition-all duration-300 transform hover:-translate-y-1"
            >
              Rezervasyon Yap
            </Link>
          </div>
        </div>
      </div>
      
      {/* Animasyon stilleri */}
      <style jsx>{`
        .animate-section .cta-content {
          opacity: 1;
          transform: translateY(0);
        }
      `}</style>
    </section>
  );
};

export default HomeCTA;